import { render } from "./CreateEdit.vue?vue&type=template&id=064e2c48&scoped=true"
import script from "./CreateEdit.vue?vue&type=script&lang=js"
export * from "./CreateEdit.vue?vue&type=script&lang=js"

import "./CreateEdit.vue?vue&type=style&index=0&id=064e2c48&lang=scss&scoped=true"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064e2c48"]])

export default __exports__